/**
 * Object update and hover handlers
 */

import { dia } from '@joint/core'
import { scalePathData } from '../../../utils/svgUtils'
import { isLightGeometry, resizeLightGeometry } from '../../../lib/lightFrameGeometry'

export function handleObjectUpdateFn(
  graph: dia.Graph | null,
  setDataVersion: React.Dispatch<React.SetStateAction<number>>,
  id: string,
  updates: Partial<any>
) {
  if (!graph) return

  const cell = graph.getCell(id)
  if (!cell || !cell.isElement()) return

  const element = cell as dia.Element

  if (updates.position) {
    element.position(updates.position.x, updates.position.y)
  }

  if (updates.size) {
    const elementType = element.get('type')
    const currentSize = element.size()
    const newWidth = updates.size.width
    const newHeight = updates.size.height

    if (isLightGeometry(element) && element.get('data')?.vertices?.length > 1) {
      resizeLightGeometry(element, newWidth, newHeight)
    } else if (elementType === 'standard.Path') {
      // For Path elements, scale the SVG path data
      const pathData = element.attr('body/d') as string
      if (pathData) {
        const scaleX = newWidth / currentSize.width
        const scaleY = newHeight / currentSize.height

        // Scale path coordinates
        const scaledPath = scalePathData(pathData, scaleX, scaleY)
        element.attr('body/d', scaledPath)
      }
      element.resize(newWidth, newHeight)
    } else if (elementType === 'standard.Image') {
      // For Image elements, update image attributes directly
      element.attr('image/width', newWidth)
      element.attr('image/height', newHeight)
      element.resize(newWidth, newHeight)
    } else {
      // For other element types, use default resize
      element.resize(newWidth, newHeight)
    }

  }

  if (updates.data) {
    element.set('data', updates.data)
    // Force React re-render when data changes
    setDataVersion(v => v + 1)
  }
}
